<template>
   <div class="">
     
       <message title="ساخت پیام جدید"  />
   </div>
</template>

<script>
import Message from '../Tickets/Message.vue';

export default {
  name: "tableItems",
  components:{Message},

 
  data() {
    return {
      
    
    };
  },
};
</script>
